<template>
  <el-dialog
    :visible.sync="workflowVisible"
    v-loading="workflowloading"
    width="90%"
    top="5vh" append-to-body
    @close="CloseWorkflow">
    <div style="height:80vh">
      <iframe :src="workflowUrl" width="100%" height="100%" frameborder="0" @load="WorkflowDetailOnload"></iframe>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'WorkflowApplyDetail',
  
  data () {
    return {
      workflowVisible: false,
      workflowloading: false,
      workflowUrl: ''
    }
  },
  methods: {
    // 查看审批记录流程ID
    ShowWorkflowApply: function (ApplyID, oasUrl,lang,token) {
      var _this = this
      _this.workflowloading = true
      _this.workflowUrl = oasUrl + '/WorkFlow/ApplyDetailForCS.aspx?applyId=' + ApplyID + '&lang=' + lang +'&token=' + token+ '&noPop=1&r=' + Math.random()
      _this.workflowVisible = true
    },
    // 关闭查看审批记录
    CloseWorkflow: function () {
      this.workflowUrl = ''
    },
    WorkflowDetailOnload: function () {
      this.workflowloading = false
    }
  }
}
</script>

<style>
  /* .el-table__header th {
    background-color: #E7E7E7;
    color: gray;
    font-weight: bold;
  }
  .el-table--border td,.el-table--border th {
    border-right: 1px solid #dddddd;;
  }
  .el-table td, .el-table th.is-leaf {
    border-bottom: 1px solid #dddddd;;
  }
  .el-dialog__body {
    padding: 10px;
  }
  .el-dialog {
    margin:0 auto;
  } */
</style>



// WEBPACK FOOTER //
// src/components/WorkflowApplyDetail.vue